import { useCallback, useEffect, useState } from "react";

const useFetch = (url) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchData = useCallback(async (signal) => {
        try {
            setLoading(true);
            setError(null);

            const response = await fetch(url, {
                signal
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const result = await response.json();

            setData(result);
        } catch (error) {
            if (error.name !== "AbortError") {
                setError(error);
            }
        } finally {
            if (!signal.aborted) {
                setLoading(false);
            }
        }
    }, [url]);

    useEffect(() => {
        const controller = new AbortController();

        fetchData(controller.signal);

        return () => {
            controller.abort();
        };
    }, [fetchData]);

    const refetch = () => {
        const controller = new AbortController();

        fetchData(controller.signal);
    };

    return {
        data,
        loading,
        error,
        refetch
    };
};

export default useFetch;